export const URLS = {
  agents: '/agents',
  arnmAccidents: '/arnmAccidents',
  arnmDashboard: '/dashboard',
  arnmMaintenance: '/arnmMaintenance',
  arnmRepairs: '/arnmRepairs',
  availability: '/availabilities-table',
  avisReport: '/avis_report',
  b2b: '/b2b',
  billing: '/billing',
  bookings: '/bookings',
  buyout: '/buyout',
  campaigns: '/campaigns',
  catalogCars: '/catalog/cars',
  catalogEbikes: '/catalog/ebike',
  communication: '/unified/mailboxes',
  competition: '/competition',
  configurations: '/configurations',
  contracts: '/contracts',
  creditCheckReport: '/credit_check_report',
  creditCheckTable: '/creditCheckTable',
  customerSuccessDashboard: '/customer-success-dashboard',
  dailyBookings: '/dailyBookings',
  defleet: '/defleet',
  drivers: '/drivers',
  emailTemplates: '/unified/templates',
  exportData: '/exportData',
  fleetVehicles: '/vehicles',
  forSaleVehicles: '/sell/availability',
  genericTickets: '/generic-tickets',
  greenCard: '/greenCard',
  guaranteeReturns: '/guarantee-returns',
  handoverCarsDelivery: '/handoverCarsDelivery',
  handoverCarsReturns: '/handoverCarsReturns',
  home: '/',
  inspections: '/inspections',
  instapaymentReports: '/instapayment_reports',
  insurances: '/insurances',
  jobs: '/jobs',
  logistics: '/logistics',
  mailBoxes: '/mailBoxes',
  marketplaceTires: '/marketplace/tires',
  myIssues: '/my-tasks',
  orders: '/orders',
  partners: '/partners',
  permissions: '/permissions',
  privateVehicles: '/privateVehicles',
  procurement: '/procurement',
  products: '/products',
  reservations: '/reservations',
  roadsideAssistance: '/roadsideAssistance',
  sellRequests: '/sellRequests',
  sellVehicles: '/sellVehicles',
  sellVehiclesB2B: '/sellVehiclesb2b',
  servicePoints: '/servicePoints',
  serviceVehicles: '/serviceVehicles',
  subscriptions: '/subscriptions',
  teams: '/teams',
  tradeTickets: '/tradeTickets',
  tradeVehicles: '/tradeVehicles',
  trafficOffenses: '/trafficOffenses',
  users: '/users',
  utilities: '/utilities',
  vendors: '/vendors',
  videos: '/videos',
};
